module.exports = __webpack_public_path__ + "img/pocket_entry_length.0adf582c.png";